import { render, staticRenderFns } from "./CookiePolicyAnnoucement.vue?vue&type=template&id=a84d8188&"
import script from "./CookiePolicyAnnoucement.vue?vue&type=script&lang=js&"
export * from "./CookiePolicyAnnoucement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports